// src/hooks/useFeatureFlag.js
import { useAuth } from '../lib/useAuth'
import { hasFeature } from '../lib/features'

export function useFeatureFlag(featureName, orgTier = null) {
  const { profile } = useAuth()
  const userTier = profile?.user_tier ?? 'free'
  return hasFeature(featureName, userTier, orgTier)
}